import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Digital from "./assets/contatore-1-digitale.png";
import Pointer from "./assets/contatore-2-lancette.png";
import Reading from "./assets/contatore-3-telelettura.png";
import DigitalActive from "./assets/contatore-1-digitale-selezionato.png";
import PointerActive from "./assets/contatore-2-lancette-selezionato.png";
import ReadingActive from "./assets/contatore-3-telelettura-selezionato.png";

import "./SelfReadModal.scss";

const SelfReadModal = (props) => {
  const { t } = useTranslation();
  const closeButtonRef = useRef(null);

  const arrayCards = [
    {
      id: 1,
      title: t("self.read.digital.title"),
      img: Digital,
      imgActive: DigitalActive,
      value: "digital",
      description: t("self.read.digital.description"),
    },
    {
      id: 2,
      title: t("self.read.pointer.title"),
      img: Pointer,
      imgActive: PointerActive,
      value: "pointer",
      description: t("self.read.pointer.description"),
    },
    {
      id: 3,
      title: t("self.read.reading.title"),
      img: Reading,
      imgActive: ReadingActive,
      value: "reading",
      description: t("self.read.reading.description"),
    },
  ];

  const [selected, setSelected] = useState(arrayCards[0].value);
  const [itemData, setItemData] = useState(arrayCards[0]);

  const _onChange = (e) => {
    setSelected(e.target.value);

    // eslint-disable-next-line eqeqeq
    setItemData(arrayCards.filter((element) => element.id == e.target.id)[0]);
  };

  useEffect(() => {
    if (closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, []);

  return (
    <div
      className="SelfReadModal modal gcap-modal search-modal fade show full-page-overlay"
      id="SelfReadModal"
      tabIndex="-1"
      role="dialog"
      data-testid="SelfReadModal"
      aria-modal="true"
      aria-label={t("self.read.modal.title")}
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="container">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("common.close")}
              onClick={props.close}
              ref={closeButtonRef}
            >
              <span className="gc-icon-functional-close" aria-hidden="true" />
            </button>
          </div>

          <div className="inner-box-container">
            <fieldset className="box-container" role="radiogroup">
              <legend className="sr-only">
                {t("self.read.modal.title")}
              </legend>
              {arrayCards.map((e, index) => {
                return (
                  <div className="box" key={index}>
                    <div className="container-checkbox">
                      <input
                        type="radio"
                        name="selfReadType"
                        id={e.id}
                        value={e.value}
                        className={selected === e.value ? "selected" : ""}
                        onChange={_onChange}
                        aria-describedby="istruzioni_lettura"
                      />
                      <span className="checkmark checkmark-radio" />
                    </div>
                    <label htmlFor={e.id} className="radio-label">
                      <div className="img-container">
                        <img
                          src={selected === e.value ? e.imgActive : e.img}
                          alt=""
                          className="img-stl"
                        />
                      </div>
                      <div className="box-text-container">
                        <h3 className="box-text headline-fs6">
                          {e.title}
                        </h3>
                        <p className="box-description headline-fs5">
                          {e.description}
                        </p>
                      </div>
                    </label>
                  </div>
                );
              })}
            </fieldset>
            <div className="text-container" id="istruzioni_lettura">
              <div className="text-header-container">
                <h3 className="text-header headline-fs6">{itemData.title}</h3>
              </div>

              <div className="text-body-container ">
                <p className="text-body headline-fs5">{itemData.description}</p>
              </div>
            </div>

            <div className="btn-container">
              <button onClick={props.close} className={"btn btn-primary"}>
                {t("common.hoCapito")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfReadModal;
